import ReactDOM from 'react-dom';

class ControlButton {
  constructor(callback, containerClassName, innerComponent) {
    this.callback = callback;
    this.containerClassName = containerClassName;
    this.innerComponent = innerComponent;
  }

  onAdd = (map) => {
    this._map = map;
    const container = document.createElement('div');
    container.className = this.containerClassName;
    ReactDOM.render(this.innerComponent, container);
    container.addEventListener('click', this.callback);

    return container;
  };
  onRemove = () => {
    const container = document.querySelector(`.${this.containerClassName}`);
    if (container) {
      container.removeEventListener('click', this.callback);
      container.parentNode.removeChild(container);
    }
    this._map = undefined;
  };
}

export default ControlButton;
